import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <main className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <p className="overline mb-2">// Checkout cancelled</p>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-4">No charge made.</h1>
      <p className="font-sans text-neutral-400 mb-8">You cancelled the checkout. Your items are still in your cart.</p>
      <div className="flex gap-3 justify-center">
        <Link to="/cart" className="btn-outline-dark">Back to cart</Link>
        <Link to="/" className="btn-signal">Keep shopping →</Link>
      </div>
    </main>
  );
}
